import { useState, useEffect, useRef } from 'react';

const useScrollIndicator = () => {
  const [showIndicator, setShowIndicator] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (wrapperRef.current) {
        let { scrollHeight, clientHeight } = wrapperRef.current;
        clientHeight = Math.ceil(clientHeight);
        scrollHeight = Math.ceil(scrollHeight);
        setShowIndicator(scrollHeight > clientHeight);
      }
    };

    checkOverflow();

    // ✅ Listen for resize events
    window.addEventListener('resize', checkOverflow);

    // ✅ Observe changes in content
    const observer = new MutationObserver(checkOverflow);
    if (wrapperRef.current) {
      observer.observe(wrapperRef.current, { childList: true, subtree: true, characterData: true });
    }

    return () => {
      window.removeEventListener('resize', checkOverflow);
      observer.disconnect();
    };
  }, []);

  const handleScroll = () => {
    if (wrapperRef.current) {
      let { scrollTop, scrollHeight, clientHeight } = wrapperRef.current;
      scrollTop = Math.ceil(scrollTop);
      clientHeight = Math.ceil(clientHeight);
      scrollHeight = Math.ceil(scrollHeight);
      setShowIndicator(scrollTop + clientHeight < scrollHeight);
    }
  };

  return { showIndicator, wrapperRef, onScroll: handleScroll };
};

export default useScrollIndicator;
